<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-4">
        <h5>連絡先グループ表示順</h5>
      </div>
      <div class="col-2">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn-right" v-on:click="back">キャンセルする</button>
      </div>
      <div class="col-2">
        <button class="btn btn-info btn btn-block" v-on:click="sort">表示順を確定する</button>
      </div>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-7">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:50px"></th>
              <th scope="col">{{ isHierarchyGroupEnabled ? "第一階層" : "グループ名" }}</th>
              <th scope="col" v-show="isHierarchyGroupEnabled">第二階層</th>
            </tr>
          </thead>
          <draggable v-model="groups" tag="tbody" animation=200 scroll-sensitivity=500>
            <tr v-for="(group) in groups" v-bind:key="group.id">
              <td align="center">≡</td>
              <td>{{ group.displayName }}</td>
              <td v-show="isHierarchyGroupEnabled">
                <table>
                  <draggable v-model="group.child" tag="tbody" animation=200 scroll-sensitivity=500>
                      <tr v-for="(child) in group.child" v-bind:key="child.id">
                        <td align="center">≡</td>
                        <td>{{ child.displayName }}</td>
                      </tr>
                  </draggable>
                </table>
              </td>
            </tr>
          </draggable>
        </table>
      </div>
      <div class="col-4">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import draggable from 'vuedraggable'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Sort',
  mixins: [sessions,path,headers],
  props: ['realms'],
  components: {
    draggable
  },
  data: function(){
    return {
      groups: [],
      message: '',
      space: '　'
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search()
        }
      }
    )
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    },
    isHierarchyGroupEnabled: function () {
      return this.$store.getters.contact.isHierarchyGroupEnabled
    }
  },
  methods: {
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
    },
    search() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var extraContactId = this.$route.params.extraContactId
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup/management/list" 
                      : "/api/group/management/public/list"
          axios
            .post(url, {
              hospitalId: hospitalId,
              extraContactId: extraContactId
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              if(this.$store.getters.contact.isHierarchyGroupEnabled) {
                response.data.data.groups.forEach(element => {
                  if (element.hierarchyNo === 1) {
                    this.groups.push({
                      id: element.id,
                      groupName: element.groupName,
                      displayName: element.groupName,
                      child: []
                    })
                  } else {
                    this.groups[this.groups.length - 1].child.push({
                      id: element.id,
                      groupName: element.groupName,
                      displayName: this.space.repeat(element.hierarchyNo - 1) + element.groupName,
                    })
                  }
                })
              } else {
                this.groups = response.data.data.groups.map(element => {
                  element.displayName = element.groupName
                  return element
                })
              }
            })
            .catch(err => {
              this.message = err.message
            })
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    sort() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                      ? "/api/hierarchygroup/management/sort" 
                      : "/api/group/management/public/sort"
          axios.put(url, {
              groups: this.groups
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/group/index'))
            }
          }).catch(err => {
              this.message = err.message
          })
        }
      }).catch((err) => {
          this.message = err.message
      })
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
.btn-sm{
  margin-left: 5px;
}
.btn-right {
  float:right;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>